import { drivewayForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * B6. Wniosek o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi gminnej (urząd gminy) — art. 29 ustawy
 * o drogach publicznych; opłata skarbowa 82 zł (część III ust. 44 pkt 2 załącznika do ustawy o opłacie skarbowej),
 * zjazd do budynku mieszkalnego zwolniony (art. 2 ust. 1 pkt 2). Brak wzoru ogólnopolskiego i przepisu o treści wniosku;
 * układ jak wzór Bierunia XX GK (https://bip.bierun.pl/download/XX-GK-zezwolenie-na-lokalizacje-zjazdu_przebudowe-istniejacego-zjazdu,29459.pdf
 * — pobrany 2026-10-22: tak): lokalizacja / przebudowa, droga, działka, tytuł prawny, cele wykorzystania nieruchomości i ich
 * zmiana; załączniki: tytuł prawny, mapa 1:500, wypis z ewidencji działek drogowych, WZ albo wypis z MPZP. Lista załączników
 * to praktyka urzędów — do potwierdzenia z wydziałem. Wspólny builder z D2 i E9: definitions/sharedRoads.ts.
 */
const B6 = drivewayForm({
  code: "B6",
  title: "Wniosek o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi gminnej",
  description: "Zezwolenie na budowę nowego albo przebudowę istniejącego zjazdu (wjazdu) z drogi gminnej do nieruchomości.",
  organ: ROAD_ORGAN.municipality,
  office: EEbiFormOffice.Municipality,
  road: "gminna",
});

export default B6;
